import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Checkbox, Divider, FormControlLabel, FormHelperText, Grid, InputAdornment, Stack, Typography } from "@mui/material";
import { connect } from 'react-redux';
import CustomButton from "../../../components/Form/CustomButton";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import "../../Orders/order.css";
import Helpers from "../../../helpers/helpers";
import CustomIconButton from "../../../components/Form/CustomIconButton";

const ServicesFiled = ({ setOpenServicesField, tempServices, error, errorYear, setTempServices, services_type, edit, setEditId, handleSaveEdit, id, handleAddServices, clear, tabDataArry, width }) => {
    const [tickID, setTickID] = useState(false)

    const handleAddDuration = () => {
        setTickID(tempServices?.options?.length);
        setTempServices((prevValues) => ({
            ...prevValues,
            options: [
                ...(prevValues?.options || []), // Ensure options is an array
                {
                    years: "", // Add the new item at the bottom
                    price: "",
                    default_option: 0,
                },
            ],
        }));
    }

    const handleDeleteFiles = (id) => {
        const tempFile = tempServices?.options
        const filteredFIle = tempFile && tempFile?.length > 0 && tempFile.filter((x, idx) =>
            id !== idx
        )
        // setSelectedServicesItem(filteredFIle);
        setTempServices((prevValues) => ({
            ...prevValues,
            options: filteredFIle,
        }));
    }

    return (
        <div className="pt-4">
            <Grid container sx={{ border: '1px solid #e0e0e0', borderRadius: "8px", backgroundColor: "#fafafa", width: "100%" }} p={2} pt={0}>
                <Grid item xs={12} pb={3}>
                    <Stack direction={{ xs: "column-reverse", sm: "row" }} pt={2} gap={1} justifyContent={"space-between"}>
                        <Stack direction={"row"} gap={1} alignItems={"center"}>
                            <div style={{ border: '1px solid #D0D0D0', borderRadius: "5px", height: "42px", width: "42px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <i className={tabDataArry?.icon} style={{ fontSize: "24px" }}></i>
                            </div>
                            <div>
                                <span className="setting-form-section-header font-size-14" >New duration option</span>
                            </div>
                        </Stack>
                        <div className="d-flex justify-content-end">
                            <CustomButton
                                borderStyle={"1px solid #999999"}
                                title={<span><i className="ri-close-fill me-2"></i>Cancel</span>}
                                press={() =>
                                    edit
                                        ? (setEditId(""), setTempServices({}), clear())
                                        : (setOpenServicesField(false), setTempServices({}), clear())
                                } height={26}
                                backgroundColor={'transparent'}
                                textColor={'#999999'}
                            />
                        </div>
                    </Stack>
                </Grid>
                <Grid container spacing={2} >
                    <Grid item xs={12} sm={3}>
                        <CustomSelect
                            data={services_type?.parent_service_types || []}
                            valueName={"id"}
                            labelName={"display_name"}
                            title={'Display Name'}
                            values={tempServices?.service_type_id || "-1"}
                            placeholder={"e.g. 3"}
                            type={"number"}
                            onChange={(e) => {
                                setTempServices((prevValues) => ({
                                    ...prevValues,
                                    service_type_id: e,
                                    service_type_name: services_type?.parent_service_types.find(service => service.id === e)?.display_name || ""
                                }))
                            }}
                            error={error && !tempServices?.service_type_id && "The display name field is required."}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <CustomTextField
                            title={'SKU'}
                            values={tempServices?.sku}
                            placeholder={"SKU12345"}
                            onChange={(e) => setTempServices((prevValues) => ({
                                ...prevValues,
                                sku: e
                            }))}
                            error={error && !tempServices?.sku && "The SKU field is required."}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <CustomTextField
                            title={'Duration'}
                            values={tempServices?.years}
                            placeholder={"e.g. 3"}
                            type={"number"}
                            onChange={(e) => setTempServices((prevValues) => ({
                                ...prevValues,
                                years: e
                            }))}
                            error={error && !tempServices?.years && "The duration field is required."}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <CustomTextField
                            title={'Price'}
                            values={tempServices?.price}
                            onChange={(e) => setTempServices((prevValues) => ({
                                ...prevValues,
                                price: e
                            }))}
                            InputProps={{
                                startAdornment: <InputAdornment position="start" className='auth-icon'>S$</InputAdornment>,
                            }}
                            type="number"
                            placeholder="0.00"
                            error={error && !tempServices?.price && "The price field is required."}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} pb={1} >
                        <Stack flexDirection={"space-between"} direction={width > 598 ? "column" : "row-reverse"} style={{ paddingTop: "10px" }}>
                            <span style={{ color: "#00000099", fontFamily: 'Manrope-SemiBold', fontSize: 14 }}>Set as default option</span>
                            <FormControlLabel
                                sx={{ marginBottom: "0px" }}
                                control={
                                    <Checkbox checked={tempServices?.default_option == 1 ? true : false}
                                        sx={{
                                            '&.Mui-checked': {
                                                color: "var(--bs-theme-color)",
                                            },
                                            color: '#52525280'
                                        }}
                                        onChange={(e) => {
                                            setTempServices((prevValues) => ({
                                                ...prevValues,
                                                default_option: e.target.checked ? 1 : 0
                                            }))
                                        }}
                                        value={tempServices?.default_option == 1 ? true : false} />
                                }
                            />
                        </Stack>
                    </Grid>
                    {
                        width > 598 ?
                            <Grid item xs={12} ml={{ xs: 0, sm: 3 }} >
                                <Grid container xs={12} border={tempServices?.options?.length > 0 && { xs: "none", sm: "1px solid #d5d5d5" }} spacing={2} p={{ xs: 0, sm: 1 }} borderRadius={2} display={"flex"} alignItems={"flex-start"}>
                                    {
                                        tempServices?.options?.length > 0 && tempServices?.options.map((x, idx) =>
                                            <React.Fragment>
                                                <Grid item xs={12} sm={3} style={{ paddingTop: "0px", display: "flex", flexWrap: "wrap", alignContent: "flex-end" }}>
                                                    <CustomSelect
                                                        data={services_type?.child_service_types || []}
                                                        valueName={"id"}
                                                        labelName={"display_name"}
                                                        title={idx === 0 && "Display Name"}
                                                        values={x?.service_type_id || "-1"}
                                                        error={error ? !x?.service_type_id && "The display name field is required." : errorYear && !/^[0-9]/.test(x?.service_type_id) && "The duration must start with an integer"}
                                                        onChange={(e) => {
                                                            const selectedService = services_type?.child_service_types.find(service => service.id === e);
                                                            setTempServices((prevValues) => ({
                                                                ...prevValues,
                                                                options: prevValues.options.map((item, i) =>
                                                                    i === idx
                                                                        ? {
                                                                            ...item,
                                                                            service_type_id: selectedService?.id,
                                                                            service_type_name: selectedService?.display_name || ""
                                                                        }
                                                                        : item
                                                                ),
                                                            }))
                                                        }}
                                                        type="number"
                                                        placeholder="e.g 3"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={1.5} style={{ paddingTop: "0px" }}>
                                                    <CustomTextField
                                                        title={idx === 0 && "SKU"}
                                                        values={x?.sku}
                                                        error={error && Helpers?.isNullOrEmptyAllowZero(x?.sku) && "The SKU field is required."}
                                                        onChange={(e) => setTempServices((prevValues) => ({
                                                            ...prevValues,
                                                            options: prevValues.options.map((item, i) =>
                                                                i === idx // Compare the index
                                                                    ? { ...item, sku: e } // Update only the matching element
                                                                    : item // Keep other elements unchanged
                                                            ),
                                                        }))}
                                                        placeholder="SKU12345"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={1.5} style={{ paddingTop: "0px" }}>
                                                    <CustomTextField
                                                        title={idx === 0 && "Year(s)"}
                                                        values={x?.years}
                                                        error={error && !x?.years && "The years field is required."}
                                                        onChange={(e) => setTempServices((prevValues) => ({
                                                            ...prevValues,
                                                            options: prevValues.options.map((item, i) =>
                                                                i === idx // Compare the index
                                                                    ? { ...item, years: e } // Update only the matching element
                                                                    : item // Keep other elements unchanged
                                                            ),
                                                        }))}
                                                        type="number"
                                                        placeholder="3"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={2} style={{ paddingTop: "0px" }}>
                                                    <CustomTextField
                                                        title={idx === 0 && "Selling Price"}
                                                        values={x?.price}
                                                        error={error && Helpers?.isNullOrEmptyAllowZero(x?.price) && "The selling price field is required."}
                                                        onChange={(e) => setTempServices((prevValues) => ({
                                                            ...prevValues,
                                                            options: prevValues.options.map((item, i) =>
                                                                i === idx // Compare the index
                                                                    ? { ...item, price: e } // Update only the matching element
                                                                    : item // Keep other elements unchanged
                                                            ),
                                                        }))}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start" className='auth-icon'>S$</InputAdornment>,
                                                        }}
                                                        type="number"
                                                        placeholder="0.00"
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={2} style={{ paddingTop: "0px" }}>
                                                    {idx === 0 && <span style={{ color: "#00000099", fontFamily: 'Manrope-SemiBold', fontSize: 14 }}>Set as default option</span>}
                                                    <Stack flexDirection={"space-between"} direction={"row"} style={{ paddingTop: "10px" }}>
                                                        <FormControlLabel
                                                            sx={{ marginBottom: "0px" }}
                                                            control={
                                                                <Checkbox checked={x?.default_option === 1 ? true : false}
                                                                    sx={{
                                                                        '&.Mui-checked': {
                                                                            color: "var(--bs-theme-color)",
                                                                        },
                                                                        color: '#52525280'
                                                                    }}
                                                                    onChange={(e) => setTempServices((prevValues) => ({
                                                                        ...prevValues,
                                                                        options: prevValues.options.map((item, i) => ({
                                                                            ...item,
                                                                            default_option: i === idx ? (e.target.checked ? 1 : 0) : 0 // Set only the selected checkbox to 1, others to 0
                                                                        })),
                                                                    }))}
                                                                    value={tempServices?.default_option === 1 ? true : false} />
                                                            }
                                                        />
                                                    </Stack>
                                                </Grid>

                                                <Grid item xs={12} sm={2} style={{ paddingTop: "0px" }} alignContent={"center"}>
                                                    {idx === 0 && <span style={{ color: "#00000099", fontFamily: 'Manrope-SemiBold', fontSize: 14 }}>Action</span>}
                                                    <Stack flexDirection={"space-between"} direction={"row"} style={{ paddingTop: "10px" }}>
                                                        {
                                                            tickID === idx ?
                                                                <>
                                                                    <CustomIconButton
                                                                        iconName={'ri-check-line'}
                                                                        onClick={() => setTickID("")}
                                                                    />
                                                                    <CustomIconButton
                                                                        iconName={'ri-close-line'}
                                                                        onClick={() => (handleDeleteFiles(idx), setTickID(""))}
                                                                    />
                                                                </>
                                                                :
                                                                <>
                                                                    <CustomIconButton
                                                                        iconName={'ri-delete-bin-line'}
                                                                        onClick={(e) => handleDeleteFiles(idx)}
                                                                        backgroundColor={'#44d62c'}
                                                                        color={'white'}
                                                                        borderStyle={"1px solid #44d62c"}
                                                                    />
                                                                </>
                                                        }
                                                    </Stack>
                                                </Grid>
                                            </React.Fragment>
                                        )}
                                </Grid>
                            </Grid>

                            :
                            tempServices?.options?.length > 0 && tempServices?.options.map((x, idx) =>
                                <React.Fragment>
                                    <Grid item xs={12}>
                                        <Divider className="" style={{ color: "blue" }} />
                                    </Grid>
                                    <Grid item xs={12} style={{ paddingTop: "0px" }}>
                                        <Stack justifyContent={"flex-end"} display={"flex"} direction={"row"} style={{ paddingTop: "10px" }}>
                                            {
                                                tickID === idx ?
                                                    <>
                                                        <CustomIconButton
                                                            iconName={'ri-check-line'}
                                                            onClick={() => setTickID("")}
                                                        />
                                                        <CustomIconButton
                                                            iconName={'ri-close-line'}
                                                            onClick={() => (handleDeleteFiles(idx), setTickID(""))}
                                                        />
                                                    </>
                                                    :
                                                    <>
                                                        <CustomIconButton
                                                            iconName={'ri-delete-bin-line'}
                                                            onClick={(e) => handleDeleteFiles(idx)}
                                                            backgroundColor={'#44d62c'}
                                                            color={'white'}
                                                            borderStyle={"1px solid #44d62c"}
                                                        />
                                                    </>
                                            }
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12} sm={3} style={{ paddingTop: "0px" }} width={"100%"}>
                                        <CustomSelect
                                            width={`${width - 160}px`}
                                            title={"Display Name"}
                                            data={services_type?.filter((x) => x?.is_parent == 1) || []}
                                            valueName={"id"}
                                            labelName={"service_type_name"}
                                            values={x?.service_type_id || ""}
                                            error={error && !x?.service_type_id && "The display name field is required."}
                                            onChange={(e) => {
                                                const selectedService = services_type.find(service => service.id == e);
                                                setTempServices((prevValues) => ({
                                                    ...prevValues,
                                                    options: prevValues.options.map((item, i) =>
                                                        i === idx
                                                            ? {
                                                                ...item,
                                                                service_type_id: selectedService?.id,
                                                                service_type_name: selectedService?.service_type_name || ""
                                                            }
                                                            : item
                                                    ),
                                                }))
                                            }}
                                            placeholder="e.g 3"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3} style={{ paddingTop: "0px" }}>
                                        <CustomTextField
                                            title={"Year(s)"}
                                            values={x?.years}
                                            error={error && !x?.years && "The display name field is required."}
                                            onChange={(e) => setTempServices((prevValues) => ({
                                                ...prevValues,
                                                options: prevValues.options.map((item, i) =>
                                                    i === idx // Compare the index
                                                        ? { ...item, years: e } // Update only the matching element
                                                        : item // Keep other elements unchanged
                                                ),
                                            }))}
                                            type="number"
                                            placeholder="3"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3} style={{ paddingTop: "0px" }}>
                                        <CustomTextField
                                            title={"Selling Price"}
                                            values={x?.price}
                                            error={error && Helpers?.isNullOrEmptyAllowZero(x?.price) && "The selling price field is required."}
                                            onChange={(e) => setTempServices((prevValues) => ({
                                                ...prevValues,
                                                options: prevValues.options.map((item, i) =>
                                                    i === idx // Compare the index
                                                        ? { ...item, price: e } // Update only the matching element
                                                        : item // Keep other elements unchanged
                                                ),
                                            }))}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start" className='auth-icon'>S$</InputAdornment>,
                                            }}
                                            type="number"
                                            placeholder="0.00"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3} style={{ paddingTop: "0px" }}>
                                        <Stack flexDirection={"space-between"} direction={"row"} alignItems={"center"}>
                                            <FormControlLabel
                                                sx={{ marginBottom: "0px" }}
                                                control={
                                                    <Checkbox checked={x?.default_option === 1 ? true : false}
                                                        sx={{
                                                            '&.Mui-checked': {
                                                                color: "var(--bs-theme-color)",
                                                            },
                                                            color: '#52525280'
                                                        }}
                                                        onChange={(e) => setTempServices((prevValues) => ({
                                                            ...prevValues,
                                                            options: prevValues.options.map((item, i) => ({
                                                                ...item,
                                                                default_option: i === idx ? (e.target.checked ? 1 : 0) : 0 // Set only the selected checkbox to 1, others to 0
                                                            })),
                                                        }))}
                                                        value={tempServices?.default_option === 1 ? true : false} />
                                                }
                                            />
                                            <span style={{ color: "#00000099", fontFamily: 'Manrope-SemiBold', fontSize: 14 }}>Set as default option</span>
                                        </Stack>
                                    </Grid>

                                </React.Fragment>

                            )
                    }

                    <Grid item xs={12} style={{ paddingTop: "0px" }}>
                        <Typography style={{ color: "#7BB9FA", fontSize: "14px", cursor: "pointer" }}
                            onClick={(e) => handleAddDuration()}><i className="ri-add-line"></i>Add Service Option</Typography>
                        {error && <FormHelperText sx={{ color: "red" }}>{error && (!tempServices?.options || !tempServices?.option?.length <= 0) && "Please add at least one duration."}</FormHelperText>}

                    </Grid>
                </Grid>

            </Grid>
            <div className="pt-3">
                <CustomButton
                    title={'Save'}
                    press={() => (edit ? (handleSaveEdit(id)) : (handleAddServices()))}
                    height={40}
                    width={"100%"}
                    backgroundColor={'#101010'}
                    textColor={'white'}
                />
            </div>

        </div>
    );
};

function mapStateToProps({ }) {
    return {
        years: [{ id: 3, name: "3 years" }, { id: 4, name: "4 years" }, { id: 5, name: "5 years" }]
    };
}


export default connect(mapStateToProps)(ServicesFiled);
